import styled from 'styled-components'

export const CardContainerCourse = styled.div`
  max-height: 9.875rem;

  img {
    height: 4rem;
    width: 4rem;
    border-radius: var(--border-radius);
  }

  border: 0.063rem solid var(--gray-200);
  border-radius: 0.125rem;

  .card-container {
    width: inherit;

    &--disabled {
      pointer-events: none;
    }
  }
`

CardContainerCourse.displayName = 'CardContainerCourse'

export const ButtonContainer = styled.div`
  bottom: 0;
  left: 0;
  padding: var(--spacer-3) 1.75rem var(--spacer-7);
  z-index: 1;
  background-color: var(--bg-primary);
`

ButtonContainer.displayName = 'ButtonContainer'

export const ContainerCoursesList = styled.div<{ hasNextPage: boolean }>`
  margin-bottom: ${({ hasNextPage }) => (hasNextPage ? '7rem' : '2rem')};
`

ContainerCoursesList.displayName = 'ContainerCoursesList'
